import React, {useEffect, useRef, useState} from 'react';
import "./MapItFp.css";

import * as Loader from 'react-spinners';

import Floorplan from "../../Models/Floorplan";

import {isMobile, isMobileOnly} from 'react-device-detect'
const MapItFp = ({setImages}) => {
    const [loading, setLoading] = useState(false);
    const [selectedSS, setSelectedSS] = useState(0);
    const [ssViewActive, setSSViewActive] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.visualViewport.width);
    const [windowHeight, setWindowHeight] = useState(window.visualViewport.height);
    const [ssDoubleClicked, setSSDoubleClicked] = useState(0);
    const [snapSize, setSnapSize] = useState(0.05);
    const [oldFpId, setOldFpId] = useState(-1);
    const [remoteFilePath, setRemoteFilePath] = useState("");    
    const [file, setFile] = useState("");
    const [fpWidth, setFpWidth] = useState(0);
    const [fpHeight, setFpHeight] = useState(0);
    const [fpX, setFpx] = useState(0);
    const [fpY, setFpy] = useState(0);
    const [fpBase64, setFpBase64] = useState("");
    const [newFpId, setNewFpId] = useState(-1);
    const [ssObjs, setSSObjs] = useState({});
    const [ssChangeMade, setSSChangeMade] = useState(false);
    const [horizontalTab,setHorizontalTab] = useState((isMobile && window.innerWidth>window.innerHeight)?true:false);
    const [ogFpWidth, setOgFpWidth] = useState(0);
    const [ogFpHeight, setOgFpHeight] = useState(0);
    const [orientation, setOrientation] = useState(getOrientation());
    
    const fpRef = useRef();
    const doubleClickRef = useRef(ssDoubleClicked);
        
    const [deviceFpRatio, setDeviceFpRatio] = useState((isMobile&&!horizontalTab) ? 1:0.8);
    const [deviceSsRatio, setDeviceSsRatio] = useState((isMobile&&!horizontalTab) ? 0.9:0.4);
    const [deviceSnapRatio, setDeviceSnapRatio] = useState((isMobileOnly) ? 1.5:1);
    
    const prod_host = "https://infinite-mountain-18925.herokuapp.com";
    
    const [shareId, setShareId] = useState("");

    const [viewportDetails, setViewportDetails] = useState({
      width: window.visualViewport.width,
      height: window.visualViewport.height,
      scale: window.visualViewport.scale,
      offsetLeft: window.visualViewport.offsetLeft,
      offsetTop: window.visualViewport.offsetTop
    });

    const viewportRef = useRef(viewportDetails);


  useEffect(() => {
    const handleResize = () => {
      if(!isMobile){
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;
        setWindowHeight(windowHeight);
        setWindowWidth(windowWidth);
      }
    
    }

    const handleViewportChange = () => {
      // console.log(ssDoubleClicked);
      if(doubleClickRef.current === 0 || viewportRef.current.scale > window.visualViewport.scale) {
        // setViewportDetails();
        setViewportDetails({
          width: window.visualViewport.width,
          height: window.visualViewport.height,
          scale: window.visualViewport.scale,
          offsetLeft: window.visualViewport.offsetLeft,
          offsetTop: window.visualViewport.offsetTop
        });
      }
    };

    const metaViewport = document.querySelector('meta[name="viewport"]');
    if (metaViewport) {
      metaViewport.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }

    const handleOrientationChange = (e) => {
      setOrientation(e.matches ? 'portrait' : 'landscape');
    }


    const urlSplit = window.location.href.split('/');
    // const shareId = urlSplit[urlSplit.length - 1];

    const shareId = "8644a7ad668d40ec03cd3b09ee879c2d";
    
    setShareId(shareId);
    handleRefresh(shareId);

    const mediaQuery = window.matchMedia("(orientation: portrait)");
    mediaQuery.addEventListener('change', handleOrientationChange);
    window.addEventListener('resize', handleResize);
    window.visualViewport.addEventListener('resize', handleViewportChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      mediaQuery.removeEventListener('change', handleOrientationChange);
      window.visualViewport.removeEventListener('resize', handleViewportChange);
    };
  }, []);

  useEffect(() => {
    handleRefresh(shareId);
  },[orientation]);

  useEffect(()=> {
    doubleClickRef.current = ssDoubleClicked;
  },[ssDoubleClicked]);

  useEffect(()=> {
    viewportRef.current = viewportDetails;
  },[viewportDetails]);

  function getOrientation() {
    if (window.matchMedia("(orientation: portrait)").matches) {
      return 'portrait';
    } else {
      return 'landscape';
    }
  }

  function handleRefresh(shareId) {
    setLoading(true);
    fetch(`${prod_host}/shared-project`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        editId: "",
        shareId: shareId
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(`Debug Log: return data from shared-project api: ${data}`);
      console.log(data)
      // console.log(Object.keys(data.projData));
      // console.log(Object.keys(data.projData[Object.keys(data.projData)[0]].floorplans).length)
      if(data && data.projData) {
        // at this point we should go through data and store into states
        let images = [];
        const windowWidth = window.visualViewport.width;
        const windowHeight = window.visualViewport.height;
        setWindowHeight(windowHeight);
        setWindowWidth(windowWidth);
        const horizontalTab = (isMobile && window.innerWidth>window.innerHeight)?true:false;
        setHorizontalTab(horizontalTab);
        const deviceFpRatio = (isMobile&&!horizontalTab) ? 1:0.8;
        // const deviceFpRatio = 1;
        const deviceSsRatio = (isMobile&&!horizontalTab) ? 0.9:0.4;
        const deviceSnapRatio = (isMobileOnly) ? 1.5:1;
        setDeviceFpRatio(deviceFpRatio);
        setDeviceSsRatio(deviceSsRatio);
        setDeviceSnapRatio(deviceSnapRatio);
        const projObj = data.projData[Object.keys(data.projData)[0]];
        const fpObj = projObj.floorplans[Object.keys(projObj.floorplans)[0]];
        // setHideLogo(projObj.hidelogo);
        setFile(fpObj.remote_file_path);
        setRemoteFilePath(fpObj.remote_file_path);
        console.log(fpObj.height);
        console.log(fpObj.width);
        const dimObj = getFrameDim (fpObj.height, fpObj.width, window.innerHeight, window.innerWidth*0.9);
        setOgFpHeight(fpObj.height);
        setOgFpWidth(fpObj.width);
        setFpWidth(deviceFpRatio*dimObj.width/windowWidth);
        setFpHeight(deviceFpRatio*dimObj.height/windowHeight);
        let fpx = ((windowWidth - deviceFpRatio*dimObj.width)/2)/windowWidth;
        let fpy = ((windowHeight - deviceFpRatio*dimObj.height)/2)/windowHeight;
        setSnapSize(fpObj.ssSize);
        setFpx(fpx);
        setFpy(fpy);
        setOldFpId(fpObj.server_floorplan_id);
        setNewFpId(fpObj.server_floorplan_id);
        for (let ssId in fpObj.snapshots) {
          let ss = fpObj.snapshots[ssId];
          let dimObj = getFrameDim(ss.height, ss.width, windowHeight, windowWidth);
          ss.renderWidth = 0.8*dimObj.width/windowWidth;
          ss.renderHeight = 0.8*dimObj.height/windowHeight;
          images.push({original: "https://d1se9yqadop5at.cloudfront.net/" + ss.remote_file_path});
        }
        setSSObjs(fpObj.snapshots);
        setImages(images);
        // setFpBase64("");
        // setSSChangeMade(false);
      }
      setLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setLoading(false);
    });
  }

  // const bind = useLongPress(() => {
  //     setLongPress(true);
  // });

  const fpClick = (event) => {
    if (event.type === "contextmenu") {
      setSelectedSS(0);
    }
    else if (selectedSS != 0) {
      console.log(`pagex: ${event.pageX}`);
      console.log(`pagey: ${event.pageY}`);
      console.log(`fpY height: ${fpY*windowHeight}`);
      console.log(`fpX width: ${fpX*windowWidth}`);
      console.log(`fpWidth: ${fpWidth*windowWidth}`);
      console.log(`fpHeight: ${fpHeight*windowHeight}`);

      // setSSObjs[selectedSS].coordinatex = event.clientX;
      // setSSObjs[selectedSS].coordinatey = event.clientY;
      console.log(`coordx: ${(event.pageX-(fpX*windowWidth))/(fpWidth*windowWidth)}`);
      console.log(`coordy: ${(event.pageY-(fpY*windowHeight))/(fpHeight*windowHeight)}`);
      ssObjs[selectedSS].coordinatex = (event.pageX-(fpX*windowWidth)-(getSSWidth().width/2))/(fpWidth*windowWidth);
      ssObjs[selectedSS].coordinatey = (event.pageY-(fpY*windowHeight)-(getSSWidth().height/2))/(fpHeight*windowHeight);
      ssObjs[selectedSS].change = "m";
      setSSChangeMade(true);
      setSSObjs({...ssObjs});
    }
    // from the event object we can get the coordiante of the click
    // use the coordinates to set the coordinates on the selcted image
  }

  const getFrameDim = (height, width, maxHeight, maxWidth) => {
    // console.log("In getFrameDim");
    // console.log(maxWidth);
    // console.log(maxHeight);
    // console.log(width);
    // console.log(height);
    if (!width) width = maxWidth;
    if (!height) height = maxHeight;
    if (width > maxWidth && height > maxHeight) {
    //   console.log(width);
    //   console.log(height);
      let wDiff = (width - maxWidth)/width;
      let hDiff = (height - maxHeight)/height;
      if (wDiff >= hDiff) {
        height = (1-wDiff)*height;
        width = (1-wDiff)*width;
      } else {
        height = (1-hDiff)*height;
        width = (1-hDiff)*width;
      }
    } else if (width > maxWidth) {
      let wDiff = (width - maxWidth)/width;
      width = (1-wDiff)*width;
      height = (1-wDiff)*height;
    } else if (height > maxHeight) {
      let hDiff = (height - maxHeight)/height;
      height = (1-hDiff)*height;
      width = (1-hDiff)*width;
    } else {
      // width and height must be less than the screen width and height
      let wDiff = (maxWidth - width)/width;
      let hDiff = (maxHeight - height)/height;
      if (wDiff >= hDiff) {
        height = (1+hDiff)*height;
        width = (1+hDiff)*width;
      } else {
        height = (1+wDiff)*height;
        width = (1+wDiff)*width;
      }
    }
    // console.log(`Debug Log: new width: ${width}`)
    // console.log(`Debug Log: new height: ${height}`)
    return {width: width, height: height}
  }

  const leftOrRight = (ssId, width) => {
    let fpWidthValOg = fpWidth*windowWidth;
    const newWindowWidth = viewportDetails.width;

    let fpxVal = fpX*newWindowWidth;
    let fpWidthVal = fpWidth*newWindowWidth;
    if (((fpxVal) + (ssObjs[ssId].coordinatex*fpWidthVal) + width)
    > (fpxVal+(fpWidthVal))) {
      if (((fpxVal) + ((fpWidthVal) - (ssObjs[ssId].coordinatex*fpWidthVal)) + width)
      > (fpxVal+(fpWidthVal))) {
        // this means both ways the image is not going to fit. So choose the larger size
        if((fpWidthVal) - (ssObjs[ssId].coordinatex*fpWidthVal) > ssObjs[ssId].coordinatex*fpWidthVal) {
          // go the right and resize
          let newSsWidth = (fpWidthVal) - (ssObjs[ssId].coordinatex*fpWidthVal);
          let newSsLength = newSsWidth * ssObjs[ssId].renderHeight/ssObjs[ssId].renderWidth;
          return 0;

        } else {
          // go to the left
          let newSsWidth = ssObjs[ssId].coordinatex*fpWidthVal;
          let newSsLength = newSsWidth * ssObjs[ssId].renderHeight/ssObjs[ssId].renderWidth;
          return -1*(width)+(fpWidthValOg*snapSize*deviceSnapRatio); // magic number 0.4? - hard type this
        }

      }
      return -1*(width)+(fpWidthValOg*snapSize*deviceSnapRatio); // magic number 0.4? - hard type this
    } else {
      return 0;
    }
  }

  const topOrBottom = (ssId, height) => {
    if (((fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight) + height)
    > (fpY*windowHeight+(fpHeight*windowHeight))) {
      return -1*height+(fpWidth*windowWidth*snapSize*deviceSnapRatio);
    } else {
      return 0;
    }
  }

  const getSnapshotStyle = (ssId) => {
    if (ssObjs[ssId].coordinatex !== 0 || ssObjs[ssId].coordinatey !== 0) {
      // console.log(`left: ${(fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth)}`);
      // console.log(`top: ${(fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight)}`);
      // let width = getSSWidth(ssId);
      // let height = getSSHeight(ssId);
      
      let {width, height} = getSSWidth(ssId);
      if (!isMobile) {
        return {position: 'absolute', width: width, height: height,
        left: ssId!==ssDoubleClicked
        ?(ssObjs[ssId].coordinatex*fpWidth*windowWidth) + (((windowWidth/2 - (0.1*windowWidth)) - (fpWidth*windowWidth))/2)
        :((ssObjs[ssId].coordinatex*fpWidth*windowWidth) + leftOrRight(ssId,width)) + (((windowWidth/2 - (0.1*windowWidth)) - (fpWidth*windowWidth))/2), 
        top: ssId!==ssDoubleClicked
        ?(ssObjs[ssId].coordinatey*fpHeight*windowHeight - 20)
        :((ssObjs[ssId].coordinatey*fpHeight*windowHeight) + topOrBottom(ssId, height) - 20)
        };
      } else {
        return {position: 'absolute', width: width, height: height,
        left: ssId!==ssDoubleClicked
        ?(ssObjs[ssId].coordinatex*fpWidth*windowWidth) + ((windowWidth-(fpWidth*windowWidth))/2)
        :((ssObjs[ssId].coordinatex*fpWidth*windowWidth) + leftOrRight(ssId,width)) + ((windowWidth-(fpWidth*windowWidth))/2), 
        top: ssId!==ssDoubleClicked
        ?(ssObjs[ssId].coordinatey*fpHeight*windowHeight - 10)
        :((ssObjs[ssId].coordinatey*fpHeight*windowHeight) + topOrBottom(ssId, height) - 10)
        };
      }

    } else {
      return {};
    }
  }

  const getSSWidth = (ssId) => {
    let ssWidth;
    if (ssId === ssDoubleClicked) {
      // adjust here for off screen
      // const windowHeight = isMobile?window.screen.height:window.innerHeight;
      // const windowWidth = isMobile?window.screen.width:window.innerWidth;
      ssWidth = ssObjs[ssId].renderWidth*windowWidth*deviceSsRatio;
      let fpxVal = fpX*windowWidth;
      let fpWidthVal = fpWidth*windowWidth;
      if (((fpxVal) + (ssObjs[ssId].coordinatex*fpWidthVal) + ssObjs[ssId].renderWidth*windowWidth*deviceSsRatio)
      > (fpxVal+(fpWidthVal))) {
        if (((fpxVal) + ((fpWidthVal) - (ssObjs[ssId].coordinatex*fpWidthVal)) + ssObjs[ssId].renderWidth*windowWidth*deviceSsRatio)
        > (fpxVal+(fpWidthVal))) {
          // this means both ways the image is not going to fit. So choose the larger size
          if((fpWidthVal) - (ssObjs[ssId].coordinatex*fpWidthVal) > ssObjs[ssId].coordinatex*fpWidthVal) {
            // go the right and resize
            let newSsWidth = (fpWidthVal) - (ssObjs[ssId].coordinatex*fpWidthVal);
            let ratio = newSsWidth/ssWidth;
            let newSsLength =  ratio * ssObjs[ssId].renderHeight*windowHeight*deviceSsRatio;
            return {width:newSsWidth,height:newSsLength};

          } else {
            // go to the left
            let newSsWidth = ssObjs[ssId].coordinatex*fpWidthVal;
            let ratio = newSsWidth/ssWidth;
            let newSsLength =  ratio * ssObjs[ssId].renderHeight*windowHeight*deviceSsRatio;
            return {width:newSsWidth,height:newSsLength};
          }
        } else {
          return {width:ssWidth,height:ssObjs[ssId].renderHeight*windowHeight*deviceSsRatio}; 
        }
      } else {
        return {width:ssWidth,height:ssObjs[ssId].renderHeight*windowHeight*deviceSsRatio}; 
      }
    } else {
      ssWidth = fpWidth*windowWidth*snapSize*deviceSnapRatio;
    }
    return {width:ssWidth,height:ssWidth};
  }

  const onDoubleClick = (ssId) => {
    setSSDoubleClicked(ssId);
  }

  const onLargeImageClick = () => {
    setSSDoubleClicked(false);
  }

  const getFpImageSrc = (base64, file) => {
    if (base64) {
      return "data:image/jpeg;base64," + base64;
    } else {
      return "https://d1se9yqadop5at.cloudfront.net/" + file;
    }
  }

  const getImageSrc = (ssObj) => {
    if (ssObj.image) {
      // console.log(`ss base64 path: ${ssObj.snapshot_id}`)
      return "data:image/jpeg;base64," + ssObj.image;
    } else {
      // console.log(`ss remote path: ${ssObj.remote_file_path}`)
      return "https://d1se9yqadop5at.cloudfront.net/" + ssObj.remote_file_path
    }
  }

  return (
      <div className="maptifp-edit-outter">
        <div className="mapitfp-snapshots">
          { !ssViewActive &&
          <div className="mapitfp-ss-inner">
              {Object.keys(ssObjs).map((ssId, index) => (
                ssId !== ssDoubleClicked && !ssObjs[ssId].deleted
                ?
                <div className="mapitfp-ss-img">
                  <img
                  className='ss-img-img'
                  id={ssId}
                  key={index} 
                  src={getImageSrc(ssObjs[ssId])} 
                  style={{
                    ...{border: ssId!==selectedSS?"1.5px solid black":"3px solid #FCC81A", 
                    borderRadius: "5px", 
                    cursor: "pointer"}, 
                    ...getSnapshotStyle(ssId)}} 
                  onClick={() => onDoubleClick(ssId)}
                  onDoubleClick={(event) => onDoubleClick(ssId)}
                  alt={`Uploaded content ${ssId}`} />
                </div>
                :
                ( !ssObjs[ssId].deleted 
                ?
                <div className="mapitfp-ss-img">
                  <img
                  className="ss-img-img-large"
                  id={ssId}
                  key={index}
                  src={getImageSrc(ssObjs[ssId])} 
                  style={{
                    ...{border: "1.5px solid black", 
                    zIndex:1, 
                    borderRadius: "5px", 
                    cursor: "pointer"}, 
                    ...getSnapshotStyle(ssId)}} 
                  onClick={() => onLargeImageClick()}
                  alt={`Uploaded content ${ssId}`} /> 
                </div>
                :
                <div className='ss-img'></div>
                )            
              ))}
          </div>
          }
        </div>
        <div ref={fpRef} className="mapitfp-floorplan">
          { !ssViewActive
          ? <img src={getFpImageSrc(fpBase64, file)} width={fpWidth*windowWidth} height={fpHeight*windowHeight} 
          onClick={(event) => fpClick(event)} 
          onContextMenu={(event) => fpClick(event)}/>
          : <img src={ssObjs[selectedSS].local_file_path} 
          width={ssObjs[selectedSS].width*windowWidth} 
          height={ssObjs[selectedSS].height*windowHeight}/>
          }
          <Loader.DotLoader
          color="#FCC81A"
          loading={loading}
          cssOverride={{borderColor: "#FCC81A"}}
          size={48}
          aria-label="Loading Spinner"
          data-testid="loader"
          />
        </div>
      </div>
  );
}

export default MapItFp;